// Components==============
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { getVh } from 'utilities/getVh';
import { SoundGroupExerciseContext } from '../../SoundGroupExercise';
import Category from '../Category/Category';
import './History.module.scss';
// =========================

export default function History() {
    const {
        answer,
        userAnswers,
        displayHistory,
        current,
        setDisplayHistory,
        words,
        useImages,
        useWords,
        dragging,
    } = useContext(SoundGroupExerciseContext);

    const scrollRef = useRef<HTMLDivElement>(null);

    const hasImage = answer.images.length && useImages;

    const height = hasImage ? getVh(0.15) : useWords ? getVh(0.2) : getVh(0.25);

    const [scrollContainerHeight, setScrollContainerHeight] = useState<
        string | number
    >(height);

    useEffect(() => {
        // super dirty hack to prevent scrollbar from starting at bottom (is being caused by the properties of row elements changing)
        if (displayHistory) {
            setScrollContainerHeight(5000);

            const timer = setTimeout(() => {
                setScrollContainerHeight(height);
            }, 50);

            return () => clearTimeout(timer);
        }
    }, [displayHistory]);

    if (!userAnswers?.length) return <></>;

    const indexGetter = userAnswers.findIndex((ua) => ua.id === answer.id);
    const currentAnswerIndex =
        indexGetter === -1 ? userAnswers.length : indexGetter;

    return (
        <div
            styleName={`wrapper ${
                hasImage && useWords
                    ? 'with-image-and-words'
                    : hasImage
                    ? 'with-images'
                    : useWords
                    ? 'with-words'
                    : ''
            }`}
            ref={scrollRef}
            style={{ height: scrollContainerHeight }}
        >
            {userAnswers
                .filter((a, i) => {
                    // Only show answer given previous to current answer
                    if (current <= i) return false;

                    if (!displayHistory && i !== currentAnswerIndex - 1)
                        return false;

                    return true;
                })
                .reverse()
                .map((a, i) => (
                    <motion.div
                        styleName={`history-row ${current > 1 ? 'active' : ''}`}
                        onClick={() => setDisplayHistory((prev) => !prev)}
                        key={i}
                        onWheel={() =>
                            !displayHistory && setDisplayHistory(true)
                        }
                        initial={{ opacity: 0.4 }}
                        animate={{ opacity: displayHistory ? 1 : 0.4 }}
                        whileHover={{ opacity: dragging ? 0.4 : 1 }}
                    >
                        <Category
                            word={words.find((w) => w.id === a.id)!}
                            index={i + 3}
                            inHistory
                        />
                    </motion.div>
                ))}
        </div>
    );
}
